var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"agentNoLogin"}},[_c('div',{staticClass:"noLogin"},[_c('img',{attrs:{"src":require("../assets/images/agent_ds.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("lanV4.noPermissions")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }